module.exports = __webpack_public_path__ + "img/huoshan.9fbc8337.png";